<template>
  <div>
    <h1 class="title is-4">{{ $t("purchase list") }}</h1>
    <span>{{ products.length }} {{ $t("products") }}</span>
    <br />
    <span class="title is-5 has-text-success"
      >{{ formatted_total_amount }} {{ $t("total") }}</span
    >

    <div class="buttons is-pulled-right">
      <button
        class="button"
        :data-tooltip="$t('clear')"
        :disabled="!products.length"
        @click="products = []"
      >
        <i class="fa fa-eraser"></i>
      </button>
      <button
        class="button"
        :data-tooltip="$t('register purchase')"
        :disabled="!products.length"
        @click="register_purchase"
      >
        <i class="fa fa-edit"></i>
      </button>
      <!-- <button
        class="button"
        :data-tooltip="$t('visa payment')"
        :disabled="!products.length"
        @click="visa_pay"
      >
        <i class="fa fa-credit-card"></i>
      </button> -->
    </div>

    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>{{ $t("quantity") }}</th>
          <th>{{ $t("product") }}</th>
          <th>{{ $t("price") }}</th>
          <th>{{ $t("subtotal") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, pidx) in products" :key="pidx">
          <td>{{ item.quantity }}</td>
          <td>{{ item.product.name }}</td>
          <td>{{ format_currency(item.purchase_price) }}</td>
          <td>
            {{
              format_currency(
                Number(item.quantity) * Number(item.purchase_price)
              )
            }}
          </td>
          <td>
            <button class="button" @click="products.splice(pidx, 1)">
              <i class="fa fa-trash has-text-danger"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <product-purchase-modal
      ref="product_purchase_modal"
      @success="add_product_to_basket"
    />
    <!-- <payment-modal
      v-if="module_settings"
      ref="payment_modal"
      :profile_uuid="module_settings.visanet_payment_profile"
    /> -->
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import {
  confirm_deletion_dialog,
  put,
  error_message,
  success_message,
  format_currency,
  generate_error_message_text,
} from "@/utils";
import { groupBy } from "lodash";
import ProductPurchaseModal from "../product_purchase_modal/Index.vue";

export default {
  name: "ShoppingCart",
  components: { ProductPurchaseModal },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    let v = this;
    return {
      products: [],
    };
  },
  methods: {
    format_currency,
    add_product(product) {
      let v = this;
      v.$refs.product_purchase_modal.show_modal(product.data);
      // v.products.push(product.data);
    },
    clear() {
      let v = this;
      v.products = [];
    },
    // visa_pay() {
    //   let v = this;
    //   v.$refs.payment_modal.show_modal(v.total_amount);
    // },
    add_product_to_basket(item) {
      let v = this;
      v.products.push(item);
      // console.log("item", item);
      // v.$emit("visanet_payment", amount);
    },
    register_purchase() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to register purchase?"),
        v,
        () => {
          v.$root.loader(true);
          put("/purchase", {
            items: v.products.map((p) => {
              return {
                product_id: p.product.product_id,
                quantity: p.quantity,
                purchase_price: p.purchase_price,
              };
            }),
            total: v.total_amount,
          })
            .then(() => {
              // console.log("asdfasdfadf");
              success_message(v.$t("purchase registered"));
              v.products = [];
            })
            .catch((error) => {
              // console.error(error);
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
  },
  computed: {
    grouped() {
      let v = this;
      let grps = groupBy(v.products, (p) => {
        return p.product_id;
      });
      return Object.keys(grps).map((key) => {
        return {
          product_id: grps[key][0].product_id,
          name: grps[key][0].name,
          quantity: grps[key].length,
          total: grps[key].reduce((acc, product) => {
            return acc + Number(product.sale_price);
          }, 0),
        };
      });
    },
    total_amount() {
      let v = this;
      let total = v.products.reduce((acc, product) => {
        return acc + Number(product.quantity) * Number(product.purchase_price);
      }, 0);
      return total;
    },
    formatted_total_amount() {
      let v = this;
      let total = v.products.reduce((acc, product) => {
        return acc + Number(product.quantity) * Number(product.purchase_price);
      }, 0);
      return format_currency(total);
    },
  },
  mounted() {},
};
</script>

<style></style>
